module.exports = "pegasus/assets/column-17-basic.png";